import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const amadeusApi = createApi({
  reducerPath: "amadeusApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_AMADEUS_DEV_URL,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  }),
  endpoints: (builder) => ({
    fetchAmadeusToken: builder.mutation({
      query: (body) => ({
        url: "v1/security/oauth2/token",
        method: "POST",
        body: new URLSearchParams(body).toString(),
      }),
    }),
  }),
});

export const { useFetchAmadeusTokenMutation } = amadeusApi;
